import React, { useContext, useState } from 'react'
import dynamic from 'next/dynamic'
import { Flex, Box } from 'pcln-design-system'
import HotelsTonight from '@/components/HotelsTonight/HotelsTonight'
import PromoFeatureBox from '@/components/PromoFeatureBox'
import Form from '@/components/Hotels/SearchForm/Form'
import ConditionalRender, {
  Experiment,
  Original
} from '@/components/ConditionalRender'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import { handleSubmitForHotels } from '@/components/Hotels/SearchForm/utils'
import StyledHeading from '@/components/StyledHeading'
import MobileHeaderWrapper from '@/components/MobileHeaderWrapper/MobileHeaderWrapper'
import useMostRecentFutureBooking from '@/hooks/useMostRecentFutureBooking'
import CrossSell from '@/components/CrossSell'
import { EmailSignUpToast } from '@/components/EmailSignUp'
import CONTENT from '@/constants/content'
import useSEMSearchHeadline from '@/hooks/useSEMSearchHeadline'
import MarketingTout from '@/components/Promos/MarketingTout/MarketingTout'
import useCityNameInFormHeadlineForSEM from '@/hooks/useCityNameInFormHeadlineForSEM'
import useContentfulSearchFormHeadlines from '@/hooks/useContentfulSearchFormHeadlines'
import useExtendStayBooking from '@/hooks/useExtendStayBooking'
import { LOCATION_SEARCH_TYPE } from '@/types'

const PRIMARY_HEADING_FALLBACK = 'Find your next hotel deal'
const SECONDARY_HEADING_FALLBACK = 'Save with exclusive rates'

const ExtendStayV3 = dynamic(
  () => import('@/components/ExtendStay/ExtendStayV3')
)

export default function HomeMobile() {
  const mostRecentFutureBooking = useMostRecentFutureBooking()
  const {
    signInStatus: { signedIn, passiveSignIn },
    customer: { firstName }
  } = useContext(BootstrapDataContext)

  const extendData = useExtendStayBooking()
  const isSignedIn = signedIn || passiveSignIn
  const [location, setLocation] = useState<LOCATION_SEARCH_TYPE | undefined>()
  const prePopHeadline = useCityNameInFormHeadlineForSEM(location)
  const SEMHeadline = useSEMSearchHeadline()
  const form = useContentfulSearchFormHeadlines('searchFormHotels')
  /**
   * TODO: Add these values to contentful
   */
  const headlineVIP = firstName
    ? CONTENT.homepage.vip.headlineWithName.replace('{firstName}', firstName)
    : CONTENT.homepage.vip.defaultHeading
  const subheadline = {
    text: isSignedIn
      ? CONTENT.homepage.hotel.signedInSubHeading
      : form?.mobileSubheadline || SECONDARY_HEADING_FALLBACK
  }

  const headlineValues = {
    text: isSignedIn
      ? headlineVIP
      : prePopHeadline ||
        SEMHeadline ||
        form?.mobileHeadline ||
        PRIMARY_HEADING_FALLBACK
  }
  const CrossSellContent = () => {
    return (
      <>
        {mostRecentFutureBooking ? (
          <CrossSell booking={mostRecentFutureBooking} />
        ) : (
          <PromoFeatureBox />
        )}
      </>
    )
  }

  return (
    <Box>
      <MobileHeaderWrapper selectedProductName="Hotels">
        <Box px={3} mt={2}>
          <Flex flexDirection="column" mb={3}>
            <StyledHeading
              {...headlineValues}
              tag="h1"
              color="text.heading"
              textStyle="heading3"
            />
            <StyledHeading
              color="text.light"
              mt={1}
              textStyle="subheading6"
              {...subheadline}
              tag="h2"
            />
          </Flex>
          <Form onSubmit={handleSubmitForHotels} setLocation={setLocation} />
        </Box>
      </MobileHeaderWrapper>
      <ConditionalRender experimentCode="HP_MBL_HOTEL_TONIGHT_PLACEMENT">
        <Experiment>
          <Box m={3}>
            <HotelsTonight />
          </Box>
        </Experiment>
      </ConditionalRender>
      <Box m={3}>
        {extendData ? (
          <ExtendStayV3 {...extendData} isMobile />
        ) : (
          <CrossSellContent />
        )}
      </Box>
      <Box m={3}>
        <MarketingTout />
      </Box>
      <Box m={3}>
        <ConditionalRender experimentCode="HP_MBL_HOTEL_TONIGHT_PLACEMENT">
          <Original>
            <HotelsTonight />
          </Original>
        </ConditionalRender>
        <Box textAlign="center" mt={4} width={1}>
          <div id="div-gpt-ad-1544641976893-0" />
        </Box>
      </Box>
      <EmailSignUpToast sourceId="LANDING_HOME_TOAST_MWEB" isMobile />
    </Box>
  )
}
